import { useEffect, useState } from 'react';
import AdminPage from '../../components/admin/AdminPage';
import CommissionForm from './components/CommissionForm';
import { CommissionPreviewForm } from './models/commissionModel';
import { Col, Row } from 'reactstrap';
import AdminListGroup, {
  DisplayItem,
} from '../../components/admin/AdminListGroup';
import useCommissionDetail from './hooks/useCommissionDetail';

const CommissionCalculator = () => {
  const [errorAlert, setErrorAlert] = useState<string | null>(null);

  const { apiErrors, doCommissionDetailPreview } = useCommissionDetail();

  const handleForm = async (form: CommissionPreviewForm) => {
    try {
      const result = await doCommissionDetailPreview(form);
      const payload: DisplayItem[] = result.map((r) => {
        return {
          title: r.key,
          value: r.value,
        };
      });

      setPreviewCommission(payload);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (apiErrors) {
      console.error(apiErrors);
      setErrorAlert(apiErrors);
    }
  }, [apiErrors]);

  const [previewCommission, setPreviewCommission] = useState<DisplayItem[]>([]);

  return (
    <AdminPage
      name={'[Renta] Calculadora de comisiones'}
      parentName={'Comisiones'}
    >
      <Row>
        <Col md={6}>
          <CommissionForm
            handlePreview={handleForm}
            handleCreateOrUpdate={() => {}}
            isCalculatorMode={true}
          />
        </Col>
        <Col>
          <AdminListGroup
            title={`Detalle de distribución de ganancias`}
            items={previewCommission}
          />
        </Col>
      </Row>
    </AdminPage>
  );
};

export default CommissionCalculator;
